// What a load still owes off its challan.
//
// A lorry can be taken into the outside parking on its number plate alone - the man at that counter
// writes down what is in front of him, and the paper may be in the cab, in a bag, or still being
// sent over. Past the plant gate it is different: the load is weighed and tipped against that paper,
// so it is collected before the barrier goes up.
//
// Which leaves a middle, and this is the rule for it. The server holds the same rule and is the one
// that actually refuses; this is here so a screen can say what is outstanding before somebody
// presses a button and finds out.

// The reference a parked load carries until its real one arrives. Not blank, because two blanks
// would collide on the shipment number the plant and its ERP agree on.
export const PROVISIONAL = 'AWAITING-CHALLAN/';

export const CHALLAN_LABELS = {
  shipmentId: 'Shipment number',
  consignor: 'Consignor / mine',
  consignee: 'Consignee',
  destination: 'Destination',
  supplier: 'Supplier',
  transporter: 'Transporter',
};

/**
 * The challan fields a trip is still short of, in the order a desk reads them off the paper.
 *
 * Empty once the load is inside the plant, and empty for one admitted at the gate - the gate
 * demanded all of it on the way in, so there is nothing outstanding to ask about.
 */
export const challanOwed = (trip) => {
  if (!trip || trip.progress > 0 || trip.admittedAtGate) return [];
  // A load arriving was sent by somebody; a load leaving is carried by somebody. Only one of the
  // two applies, and the desk is asked for whichever the movement makes it answerable for.
  const wanted = ['shipmentId', 'consignor', 'consignee', 'destination',
    trip.movementType === 'UNLOAD' ? 'supplier' : 'transporter'];
  return wanted.filter((key) => {
    const held = String(trip[key] ?? '').trim();
    return !held || (key === 'shipmentId' && held.startsWith(PROVISIONAL));
  });
};

/** What is outstanding, as a sentence a desk can act on. */
export const challanOwedText = (owed) => (owed.length
  ? `${owed.map((key) => CHALLAN_LABELS[key]).join(', ')} ${owed.length === 1 ? 'is' : 'are'} still to come off the challan.`
  : '');

/** The shipment number a parked load is carrying, or empty while it is only a placeholder. */
export const realShipment = (trip) => {
  const held = String(trip?.shipmentId ?? '').trim();
  return held.startsWith(PROVISIONAL) ? '' : held;
};
